import { getJwtTools } from "@/components/authentication/utils";
import { useEffect, useState } from "react";

/**
 * Returns whether the current user's group permission allows creating private
 * Large Site Screen runs. Defaults to true (unrestricted) when the flag is absent.
 */
export const useCanCreatePrivateLss = () => {
  const [canCreatePrivate, setCanCreatePrivate] = useState(true);
  useEffect(() => {
    getJwtTools().then((tools) => {
      const val = (tools?.comprehensive as any)?.largeSite?.canCreatePrivate;
      if (val === false) setCanCreatePrivate(false);
    });
  }, []);
  return canCreatePrivate;
};

/**
 * Returns whether the current user's group permission allows creating private
 * Portfolio Insights portfolios. Defaults to true (unrestricted) when the flag is absent.
 */
export const useCanCreatePrivatePortfolio = () => {
  const [canCreatePrivate, setCanCreatePrivate] = useState(true);
  useEffect(() => {
    getJwtTools().then((tools) => {
      const val = tools?.comprehensive?.portfolioInsights?.canCreatePrivate;
      if (val === false) setCanCreatePrivate(false);
    });
  }, []);
  return canCreatePrivate;
};

/**
 * Returns whether the current user's group permission allows creating private
 * Severities runs. Defaults to true (unrestricted) when the flag is absent.
 */
export const useCanCreatePrivateSeverities = () => {
  const [canCreatePrivate, setCanCreatePrivate] = useState(true);
  useEffect(() => {
    getJwtTools().then((tools) => {
      const val = tools?.comprehensive?.severities?.canCreatePrivate;
      if (val === false) setCanCreatePrivate(false);
    });
  }, []);
  return canCreatePrivate;
};
